import { Alert, Container, SxProps } from '@mui/material';

import { Box } from '@mui/material';

export function Page({ children }: { children: React.ReactNode }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: 'calc(100vh - 64px)',
        backgroundColor: 'background.2',
      }}
    >
      {children}
    </Box>
  );
}

function PageHeader({ children, sx }: { children: React.ReactNode; sx?: SxProps }) {
  return (
    <Box
      sx={{
        height: '228px',
        backgroundColor: 'background.1',
        borderBottom: '1px solid',
        borderColor: 'border.1',
        ...sx,
      }}
    >
      <Container sx={{ height: '100%' }} maxWidth="xl">
        {children}
      </Container>
    </Box>
  );
}

export function Page404({ children, sx }: { children: React.ReactNode; sx?: SxProps }) {
  return (
    <PageHeader sx={sx}>
      <Box className="flex flex-col h-full justify-center">{children}</Box>
    </PageHeader>
  );
}

function PageContent({ children }: { children: React.ReactNode }) {
  return (
    <Container sx={{ height: '100%', pb: 4 }} maxWidth="xl">
      {children}
    </Container>
  );
}

Page.Header = PageHeader;
Page.Content = PageContent;
Page.P404 = Page404;
